import axios from 'axios';
import  baseUrl  from '@/base-url.js'
import AlbumImageUrlCache from '@/modules/album/services/AlbumImageUrlCache';

const API_URL = baseUrl.url +'/api/auth/';

class AuthService {
    login(user) {
        return axios
            .post(API_URL + 'signin', {
                username: user.username,
                password: user.password,
                appType: user.appType
            })
            .then(response => {
                if (response.data.data.accessToken) {
                    localStorage.setItem('user', JSON.stringify(response.data.data));
                }
                return response.data.data;
            }).catch(err => {
                console.log(err)
                return Promise.reject(err);
            });
    }

    //xóa thông tin người dùng khỏi local storage khi thoát đăng nhập
    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('domain');
        AlbumImageUrlCache.clear();
    }

    // register(user) {
    //     return axios.post(API_URL + 'signup', {
    //         username: user.username,
    //         email: user.email,
    //         password: user.password
    //     });
    // }
}

export default new AuthService();
